import { get } from '../utils/api';

class SpecialNeedsDesignationService {
  getAll(options?: Object) {
    return get('/specialNeedsDesignations', options);
  }
}

export default SpecialNeedsDesignationService;
